<div class="betriebskostenspiegel stage{{stage}}" [class.singlehouse]="!isApartementBuilding">
  <div class="building" #building>
    @if (isApartementBuilding) {
      <svg
        aria-hidden="true"
        class="apartment-building"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 84 93">
      <path class="wall" d="M55.7,23.3H27.9H7.5v67.6h27.9V67.5h15.1v23.4h26.2V23.3H55.7z M14.7,26.8h9.8v9.8h-9.8V26.8z M14.7,47.8h9.8
				v9.8h-9.8V47.8z M24.5,78.9h-9.8V68.7h9.8V78.9z M46.7,57.6h-9.8v-9.8h9.8V57.6z M46.7,36.6h-9.8v-9.8h9.8V36.6z M68.8,79.7H59
				V68.8h9.8V79.7z M68.9,57.6h-9.8v-9.8h9.8V57.6z M68.9,36.6h-9.8v-9.8h9.8V36.6z"/>
      <path class="roof" d="M77.4,21.8h-1.3L64.6,8.5V7.7H25.4V3.6h0.8V1.7h-7.4v1.9h0.7v4.1h-3.1v0.8h0.1l-9,13.3H6.6
				c0,0-0.8,0.2-0.8,0.7s0.7,0.8,0.7,0.8h0.9l0,0h16h4.4h27.8l0,0l0,0h20.9v0.1h0.8h0.1l0,0l0,0c0,0,0.7-0.4,0.7-0.8
				C78.2,22,77.4,21.8,77.4,21.8z"/>
      </svg>
    }

    @if (!isApartementBuilding) {
      <svg
        aria-hidden="true"
        class="singlehouse"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 84 93">
      <path class="roof" d="M80.8,35h-1.4L66.8,20.4v-0.9H45l-2.2-2.4l-2.4,2.4H23.7V15h0.9v-2.1h-8.1V15h0.8v4.5h-3.4v0.9H14L4,35H3
		    c0,0-0.9,0.3-0.9,0.8s0.8,0.9,0.8,0.9h1v-0.1h17.6h4.8l16.3-16.3l14.3,16.3l0,0l0,0h22.9v0.1h0.9h0.1l0,0l0,0c0,0,0.8-0.4,0.8-0.9
		    C81.7,35.3,80.8,35,80.8,35z"/>
      <path class="wall" d="M57,36.7L42.7,20.4L26.4,36.7H3.9v43.8h30.7V54.8h16.6v25.7H80V36.7H57z M22.7,67.3H11.9V56.1h10.8V67.3z
		    M48.3,43.8H37.5V33h10.8V43.8z M71.4,68.2H60.6v-12h10.8V68.2z"/>
      </svg>
    }

    <span class="label">{{textKeyPrefix + '.yourbuilding' | translate: {kosten: this.value | number: '1.2-2'} }} @if (hasHint) {
      <dialog-infotext [textkeyContent]="textKeyPrefix + '.yourbuilding.hint'"></dialog-infotext>
    }</span>
  </div>
  <ol class="stages">
    @for (currentStage of stages; track currentStage; let i = $index) {
      <li class="stage{{i}}" [class.active]="i === stage">
        <strong [id]="'stage-' + stage" [attr.aria-labelledby]="i === stage ? 'your-building' : null">{{ currentStage }}</strong>
        <span [id]="i === stage ? 'your-building' : null" class="label" [innerHTML]="textKeyPrefix + '.stage.' + i | translate"></span>
      </li>
    }
  </ol>
  <div class="direction">
    <span></span>
    <span class="label" [innerHTML]="textKeyPrefix + '.better' | translate"></span>
  </div>
  <div class="legend">
    <div class="unit-text" [innerHTML]="textKeyPrefix + '.unit.text' | translate"></div>
    <p [innerHTML]="textKeyPrefix + '.legend.title' | translate"></p>
    <div class="grid-x">
      <div class="cell medium-4">
        <span class="circle circle-0"></span>
        <span [innerHTML]="textKeyPrefix + '.legend.0' | translate"></span>
      </div>
      <div class="cell medium-4">
        <span class="circle circle-1"></span>
        <span [innerHTML]="textKeyPrefix + '.legend.1' | translate"></span>
      </div>
      <div class="cell medium-4">
        <span class="circle circle-2"></span>
        <span [innerHTML]="textKeyPrefix + '.legend.2' | translate"></span>
      </div>
    </div>
  </div>
</div>
